// extracted by mini-css-extract-plugin
module.exports = {"seo-info":"SectionSeoInfo_seo-info__a1K1_","container":"SectionSeoInfo_container__DNraM","seo-info__paragraph":"SectionSeoInfo_seo-info__paragraph__2MzkD"};